
export interface IRsyncRemote {
    dst_paths:string
    login:string
    password:string
    port:number
    private_key:string
    server:string    
    sftp:boolean    
    sync_paths:string[]
}


export const getDefaultRsyncRemote = ():IRsyncRemote => {
    return {        
        dst_paths:'',
        login:'',
        password:'',
        port:22,
        private_key:'',
        server:'',
        sftp:false,
        sync_paths:[]
    }
} 